module.exports = __webpack_public_path__ + "static/media/season-illustration--cropped@1x.e2b7c9cf.png";